import { createAbilityForUser } from 'utils/casl/ability-utils';
import { createTransform } from 'redux-persist';
/* eslint-disable import/prefer-default-export */
import localForage from 'localforage';

const isDebug = process.env.NODE_ENV !== 'production';
const SetTransform = createTransform(
  (inboundState) => {
    // userInitiatedLogout is intent for the redirect happening right now, and
    // sessionChecked is a fact about this page load. Neither must survive into
    // the next one, so a new load always re-checks the session cookie.
    const { userInitiatedLogout, sessionChecked, ...rest } = inboundState;
    return rest;
  },
  (outboundState) => {
    const ability = outboundState.ability
      ? createAbilityForUser(outboundState.ability.j)
      : null;
    return { ...outboundState, ability };
  },
  { whitelist: ['auth'] }
);

localForage.config({
  name: 'Sweat440 Dashboard',
  storeName: 'sweat440-dashboard',
});

export const rootPersistConfig = {
  key: 'root',
  storage: localForage,
  debug: isDebug,
  transforms: [SetTransform],
  whitelist: ['me', 'auth'],
};
